/**
 * Which user guide page each portal screen's `?` button opens.
 *
 * WHY a copy of `greezmate-userguide/portal_links.py`: the guide is built in Python and the
 * portal cannot import it. The guide's build checks every anchor below exists, so keep the
 * two lists in step. Change one, change the other.
 *
 * Keys are routes under `/app`. A screen matches the longest key that starts its route, so
 * `jobs/123/edit` opens the `jobs` page. Screens with no match open the guide's front page.
 */
export const HELP_LINKS: Readonly<Record<string, string>> = {
  dashboard: 'home',
  customers: 'customers',
  'customers/debtors': 'customers',
  'customers/overdue-invoices': 'customers',
  vehicles: 'vehicles',
  'vehicles/service-dues': 'vehicles',
  'job-kits': 'job-templates',
  quotes: 'quotes',
  jobs: 'jobs',
  invoices: 'invoices',
  'invoices/banking': 'banking',
  reports: 'reports',
  notifications: 'reminders',
  'tenant-information': 'settings',
  'tenant-information/basic': 'settings-basic',
  'tenant-information/tax': 'settings-tax',
  'tenant-information/banking': 'settings-banking',
  'tenant-information/notifications': 'settings-notification',
  profile: 'settings-your-profile',
};

const APP_PREFIX = '/app/';

/** Full guide address for the screen at `routerUrl`, e.g. `/app/invoices/banking?tab=1`. */
export function helpUrlFor(routerUrl: string, guideBaseUrl: string): string {
  const base = guideBaseUrl.replace(/\/+$/, '');
  const anchor = anchorFor(routerUrl);
  return anchor ? `${base}/#${anchor}` : `${base}/`;
}

// ---- internals ----

function anchorFor(routerUrl: string): string | undefined {
  const path = routerUrl.split(/[?#]/)[0];
  if (!path.startsWith(APP_PREFIX)) return undefined;

  const segments = path.slice(APP_PREFIX.length).split('/').filter(Boolean);
  // Longest match first, so `invoices/banking` wins over `invoices`.
  for (let length = segments.length; length > 0; length--) {
    const anchor = HELP_LINKS[segments.slice(0, length).join('/')];
    if (anchor) return anchor;
  }
  return undefined;
}
